import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto',
    gap: '1rem',
    borderRadius: '0.5rem',
    boxSizing: 'border-box',
    padding: '0.25rem 0.5rem',

    '&:hover': {
      backgroundColor: theme.palette.grey[100]
    }
  },

  dragHandle: {
    cursor: 'grab',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  email: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem'
  },

  subject: {
    fontSize: theme.size.sm,
    fontWeight: 'bold'
  },

  info: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: '1rem'
  },

  from: {
    fontSize: theme.size.sm
  },

  date: {
    fontSize: theme.size.sm
  },

  delete: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  deleteButton: {
    color: theme.palette.textAlt,
    cursor: 'pointer'
  }
}))

export default useStyles
